import { Filter } from 'src/services/searchProducts/dtos'

const PRICE_FACET = 'price'

// IB-324: Preço abre sempre, mesmo com is_open=false da BeOnly. Casa pelo facet
// do contrato Lean, não por `attribute === 'Preço'` — o label é texto editável no painel.
const isAlwaysOpen = (filter: Filter): boolean => filter.id === PRICE_FACET

export const getOpenFilterIndexes = (filters?: Filter[]): number[] => {
  return (filters ?? [])
    .map((filter, index) =>
      filter.isOpen || isAlwaysOpen(filter) ? index : -1
    )
    .filter((index) => index >= 0)
}
